export default {
  /**
   * @param {Object} info 默认年份与地方信息
   * @param {String|Number} info.year 年份
   * @param {String} info.location 地方
   * @param {Object} locationInfo 对象的 key 为某种大会所有默认开会的地方
   */
  getUrlParam: (info, locationInfo) => {
    let pathNameSplit = window.location.pathname.split('/')
    let year = pathNameSplit[1]
    let location = pathNameSplit[2] === undefined || !pathNameSplit[2] ? '-1' : pathNameSplit[2]

    if (!year || typeof Number(year) !== 'number' || isNaN(Number(year))) {
      year = info.year
      window.history.replaceState({}, '', `/${year}/${location}`)
    }

    if (location === '-1' || Object.keys(locationInfo).indexOf(location) < 0) {
      location = info.location
      window.history.replaceState({}, '', `/${year}/${location}`)
    }

    return { year, location }
  },
  /**
   * 把大会的组件应用和大会属性信息 存在 store 中
   * @params {} 对象
   */
  setKeyInfoToStore: ({ year, location, locationCN, store, themeOptions, defaultCon, componentsApplyInfo }) => {
    if (typeof Number(year) === 'number' && !isNaN(year)) {
      store.commit('SET_COMPONENTS_CONFIG', componentsApplyInfo)
      store.commit('SET_CON_KEYINFO', {
        year,
        location,
        locationCN,
        con: defaultCon.con,
        theme: (componentsApplyInfo['theme'] && themeOptions.find(t => t.name.toLowerCase() === componentsApplyInfo['theme'].toLowerCase())) || {}
      })
    }
  }
}
